import React from 'react';

const StepNavigator = ({ steps, activeStep, onStepChange }) => {
  const handlePrev = () => {
    if (activeStep > 0) onStepChange(activeStep - 1);
  };

  const handleNext = () => {
    if (activeStep < steps.length - 1) onStepChange(activeStep + 1);
  };

  return (
    <div className="flex items-center space-x-2 flex-wrap gap-y-2">
      {/* Previous button */}
      <button
        onClick={handlePrev}
        disabled={activeStep === 0}
        className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-150 ${
          activeStep === 0
            ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Step pills */}
      {steps.map((step, index) => (
        <button
          key={index}
          onClick={() => onStepChange(index)}
          className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-150 whitespace-nowrap ${
            index === activeStep
              ? 'bg-blue-600 text-white shadow-sm'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          {step.shortLabel || step.label}
        </button>
      ))}

      {/* Next button */}
      <button
        onClick={handleNext}
        disabled={activeStep === steps.length - 1}
        className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-150 ${
          activeStep === steps.length - 1
            ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
};

export default StepNavigator;
